import { dateFormat } from '@constants/dateFormat'
import { useLocalStorage } from '@gravitate-js/the-armory'
import { useUserSettings } from '@hooks/settings'
import moment from 'moment/moment'
import { useMemo } from 'react'

export function usePersistentDateRangeFilter(
  filterStorageKey: string,
  defaultRange = { back: -3, ahead: 1, fromDate: undefined, toDate: undefined }
) {
  /// Custom hook to go along with the DateRangeFilter component.
  // Manages storing the days ahead and days back properties in local storage.

  const { updateSetting } = useUserSettings()
  const { value: storageValue, setValue } = useLocalStorage(filterStorageKey, defaultRange)

  const dateRange = useMemo(() => {
    if (storageValue.fromDate && storageValue.toDate) {
      return {
        fromDate: moment(storageValue.fromDate),
        toDate: moment(storageValue.toDate),
      }
    }
    return {
      fromDate: moment().add(storageValue.back, 'days'),
      toDate: moment().add(storageValue.ahead, 'days'),
    }
  }, [storageValue])

  function setDateRange(rangePayload: { back: number; ahead: number; fromDate: Date; toDate: Date }) {
    if (typeof rangePayload === 'function') return
    setValue(rangePayload)
    updateSetting(filterStorageKey, rangePayload)
  }

  return [
    dateRange,
    storageValue,
    setDateRange, // For passing to the DateRangeFilter component to handle persisting the date range.
  ]
}
